import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Stage1 from './Stage1';
import Stage2 from './Stage2';

// Styles
import styles from './index.module.sass';

export default function GrowingTogether(props) {
  const { device } = props;
  const { screenSize } = device;
  const { t } = useTranslation('growingtogether');

  const [stageSelected, setStageSelected] = useState(1);

  return (
    <div className={`${styles.growingTogether} ${styles[screenSize]}`}>
      <div className={styles.header}>
        <div className={styles.bonus}>{t('bonus')}</div>

        <h1 className={styles.title}>
          {stageSelected === 1
            ? t('stage1Title')
            : t('stage2Title')}
        </h1>
      </div>

      <div className={styles.stageSelector}>
        <button
          type='button'
          className={`${styles.stageButton} ${
            stageSelected === 1 ? styles.active : ''
          }`}
          onClick={() => setStageSelected(1)}>
          {t('stage1')}
        </button>

        <button
          type='button'
          className={`${styles.stageButton} ${
            stageSelected === 2 ? styles.active : ''
          }`}
          onClick={() => setStageSelected(2)}>
          {t('stage2')}
        </button>
      </div>

      {stageSelected === 1 ? <Stage1 {...props} /> : <Stage2 {...props} />}
    </div>
  );
}